/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedWorkflowsRouteImport } from './routes/_authenticated/workflows'
import { Route as AuthenticatedSettingsIntegrationsRouteImport } from './routes/_authenticated/settings/integrations'
import { Route as AuthenticatedCConversationIdRouteImport } from './routes/_authenticated/c/$conversationId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorkflowsRoute = AuthenticatedWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIntegrationsRoute =
  AuthenticatedSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCConversationIdRoute =
  AuthenticatedCConversationIdRouteImport.update({
    id: '/c/$conversationId',
    path: '/c/$conversationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/workflows': typeof AuthenticatedWorkflowsRoute
  '/c/$conversationId': typeof AuthenticatedCConversationIdRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/workflows': typeof AuthenticatedWorkflowsRoute
  '/': typeof AuthenticatedIndexRoute
  '/c/$conversationId': typeof AuthenticatedCConversationIdRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/workflows': typeof AuthenticatedWorkflowsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/c/$conversationId': typeof AuthenticatedCConversationIdRoute
  '/_authenticated/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/workflows'
    | '/c/$conversationId'
    | '/settings/integrations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/workflows'
    | '/'
    | '/c/$conversationId'
    | '/settings/integrations'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/workflows'
    | '/_authenticated/'
    | '/_authenticated/c/$conversationId'
    | '/_authenticated/settings/integrations'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workflows': {
      id: '/_authenticated/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AuthenticatedWorkflowsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/integrations': {
      id: '/_authenticated/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/c/$conversationId': {
      id: '/_authenticated/c/$conversationId'
      path: '/c/$conversationId'
      fullPath: '/c/$conversationId'
      preLoaderRoute: typeof AuthenticatedCConversationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedWorkflowsRoute: typeof AuthenticatedWorkflowsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCConversationIdRoute: typeof AuthenticatedCConversationIdRoute
  AuthenticatedSettingsIntegrationsRoute: typeof AuthenticatedSettingsIntegrationsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedWorkflowsRoute: AuthenticatedWorkflowsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCConversationIdRoute: AuthenticatedCConversationIdRoute,
  AuthenticatedSettingsIntegrationsRoute:
    AuthenticatedSettingsIntegrationsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
